import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export const ConfirmDialog = ({ visible, onCancel, onConfirm = onCancel, header = "Confirmación", message = "¿Realmente desea realizar esta acción?", loading = false, acceptLabel = "Si", rejectLabel = "No", acceptClassName = "p-button" }) => {
    return (
        <Dialog
            header={header}
            visible={visible}
            style={{ width: '48rem', maxWidth: '95vw' }}
            onHide={onCancel}
        >
            <div className="pt-4 pb-2 px-2">
                <div className="flex align-items-center gap-4 mb-6">
                    <span className="pi pi-exclamation-triangle text-5xl text-500" />
                    <span className="text-xl text-800">{message}</span>
                </div>
                <div className="flex justify-content-end gap-3">
                    <Button className={`${acceptClassName} px-5`} icon="pi pi-check" label={acceptLabel} onClick={onConfirm} loading={loading} disabled={loading} rounded />
                    <Button className="p-button px-5" icon="pi pi-times" label={rejectLabel} onClick={onCancel} disabled={loading} rounded />
                </div>
            </div>
        </Dialog>
    );
};